import React, { useEffect, useState } from "react";
import styles from './ProjectSettings.module.scss'
import { connect } from "react-redux";
import { CardItem } from "../../../../../components/card/Card";
import Input from "../../../../../components/Input";
import { updateBodyBuilder } from "../../../../../redux/actions/DeploymentActions";
import { generateSlug } from "../../../../../helpers/common";
import FoldingBlock from "../../../../../components/folding/FoldingBlock";

function ProjectSettings({
                             categories, tags, messages,
                             dispatch, bodyBuilder, ...props
                         }) {

    const [name, setName] = useState(bodyBuilder.project_name);
    const [git, setGit] = useState(bodyBuilder.project_git_url);

    useEffect(() => {
        // set from local storage
        setName(bodyBuilder.project_name);
        setGit(bodyBuilder.project_git_url);
    }, [
        bodyBuilder.project_name,
        bodyBuilder.project_git_url,
    ]);

    const highlightedButton = messages.find(m => m.container === `blah-blah-blah` && m.target === 'add-button');
    const highlightedButtonStyles = highlightedButton ? ' ' + styles[`add--highlight`] : '';

    return (
        <>
            <CardItem id='project-settings-name' messages={messages}>
                <Input
                    name='project_name'
                    placeholder='Project name'
                    iconLeft='fas fa-cubes'
                    maxLength={50}
                    isValid={messages.find(m => m.target === `project-settings-name`) ? false : undefined}
                    error={messages.find(m => m.target === `project-settings-name`)?.message}
                    value={name || ''}
                    onChange={e => {
                        const {value} = e.target;
                        dispatch(updateBodyBuilder({
                            project_name: value,
                            custom_stack_code: generateSlug(value),
                        }));
                        setName(value)
                    }}
                    required
                />
            </CardItem>
            <CardItem id='project-settings-git' messages={messages}>
                <FoldingBlock
                    title='Git repository'
                    id='project-settings-git-url'
                    folded={true}
                >
                    <Input
                        name='project_git_url'
                        placeholder='Git repository'
                        // hint={`The Git repository of the project will be searched for the ‘docker-compose.yml’ file in the root directory of the repository. If not found, a docker-compose.yml file will be generated based on the applications added to your custom stack`}
                        iconLeft='fas fa-cubes'
                        isValid={messages.find(m => m.target === `project-settings-git-url`) ? false : undefined}
                        error={messages.find(m => m.target === `project-settings-git-url`)?.message}
                        value={git || ''}
                        onChange={e => {
                            const {value} = e.target;
                            dispatch(updateBodyBuilder({project_git_url: value}));
                            setGit(value);
                        }}
                    />
                </FoldingBlock>
            </CardItem>
        </>
    )
}

const mapStateToProps = state => ({
    bodyBuilder: state.deployment.bodyBuilder,
});

export default connect(mapStateToProps)(ProjectSettings)